import styled from "styled-components"
import { rem } from "polished"
import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"
import { Button } from "@components/Buttons"

export const Total = styled.div`
  font-size: ${rem(15)};
  font-family: ${(p) => p.theme.fonts.serif};
`
// @ts-ignore
export const Price = styled(Box)`
  font-size: 2rem;
  font-weight: normal;
  font-family: ${(p) => p.theme.fonts.serif};
  margin-left: 0.75rem;
`

export const AddToBag = styled(Button)`
  @media screen and (max-width: ${breakpoints.small}) {
    height: 3rem;
    font-size: ${rem("14px")};
    padding: 0;
  }
`
